// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/flight-time-definitions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/flight-time-definitions/flight-time-definitions.js';

mount([g0]);
